import { CRUD } from "@/shared/components";
import {
  OrganizationsListQuery,
  OrganizationShowQuery,
  DeleteOrganizationsMutation,
  RestoreOrganizationsMutation,
} from "@/admin/entities/organizations";
import { useOrganizationsManagement, type OrganizationRow } from "../model";
import * as OrganizationsSchemas from "../model/schemas";
import {
  OrganizationShowComponent,
  OrganizationBillingRequisitesComponent,
  OrganizationTagTypesComponent,
  OrganizationUsersComponent,
  OrganizationContractPaymentsComponent,
  OrganizationRevenueShareReportsComponent,
} from "@/admin/features/organizations";

/**
 * UI компонент для управления организациями
 * Чистый презентационный компонент, использует логику из model слоя
 * GraphQL операции импортирует из organization entity
 */
export function Organizations() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useOrganizationsManagement();

  return (
    <CRUD<OrganizationRow>
      listQuery={OrganizationsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={OrganizationsSchemas.filterSchema}
      createSchema={OrganizationsSchemas.createSchema}
      createInitialVariables={
        OrganizationsSchemas.createOrganizationInitialVariables as Partial<OrganizationRow>
      }
      editSchema={OrganizationsSchemas.buildEditSchema(
        OrganizationShowComponent,
        OrganizationBillingRequisitesComponent,
        OrganizationUsersComponent,
        OrganizationTagTypesComponent,
        OrganizationContractPaymentsComponent,
        OrganizationRevenueShareReportsComponent
      )}
      editQuery={OrganizationShowQuery}
      deleteMutation={DeleteOrganizationsMutation}
      restoreMutation={RestoreOrganizationsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
